import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LoggerService } from '../../../../services/logger-services/logger.service';

/**
 * Agent Pills Component
 * 
 * Displays clickable suggestion pills/buttons for agent interactions.
 * Pills provide quick-action prompts that users can click to send predefined questions.
 * 
 * Features:
 * - Displays array of text suggestions as clickable pills
 * - Disables interaction when loading
 * - Emits selected pill text to parent component
 * 
 * Usage:
 * <app-agent-pills 
 *   [pills]="suggestionArray" 
 *   [isDisabled]="isLoading"
 *   (pillClicked)="onPillSelected($event)">
 * </app-agent-pills>
 */
@Component({
  selector: 'app-agent-pills',
  templateUrl: './agent-pills.component.html',
  styleUrls: ['./agent-pills.component.scss']
})
export class AgentPillsComponent {
  @Input() pills: string[] = [];
  @Input() isDisabled: boolean = false;
  @Input() idPrefix: string = 'agent_pill';
  
  @Output() pillClicked = new EventEmitter<string>();

  constructor(private logger: LoggerService) {}

  /**
   * Handle pill click event
   * Emits pill text to parent if not disabled
   * 
   * @param pill - Text of the clicked pill
   */
  onPillClick(pill: string): void {
    try {
      if (this.isDisabled) {
        return;
      }
      this.pillClicked.emit(pill);
    } catch (error: any) {
      this.logger.logInfo('[AgentPills] Error handling pill click', 'onPillClick', error);
    }
  }
}
